import type { captureException as CaptureException } from '@sentry/nextjs';
import type { CaptureContext } from '@sentry/types';

export type AuthorizationHeader = { Authorization: string } | Record<string, never>;

export enum AuthorizationType {
    Basic = 'Basic',
    Bearer = 'Bearer',
}

export type Token = string | null;
export type TokenGetter = () => Token;
export type TokenSetter = (token: Token) => void;

export type ErrorMessage = { code: string; message: string };
export type PropertyError = { [path: string]: ErrorMessage[] };
export type ApiErrorResponse = { error: PropertyError };

export enum HttpMethod {
    Get = 'GET',
    Post = 'POST',
}

export type CaptureExceptionSignature = typeof CaptureException;
export type RequestPayload = Record<string, unknown> | null | void;
export type RequestContext = {
    url: string;
    method: HttpMethod;
    headers: HeadersInit;
    payload: RequestPayload;
};

export type { CaptureContext };
